import { render } from "./bottomLoading.vue?vue&type=template&id=6e1c62b6&scoped=true"
import script from "./bottomLoading.vue?vue&type=script&lang=js"
export * from "./bottomLoading.vue?vue&type=script&lang=js"

import "./bottomLoading.vue?vue&type=style&index=0&id=6e1c62b6&scoped=true&lang=less"

import exportComponent from "/disk2/var/jenkins/workspace/prod__cosmic-mall-h5-entry/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1c62b6"]])

export default __exports__